import createOptIn from './optIn';
import createOptOut from './optOut';
import createSaveInteraction from './saveInteraction';
import createFetchOpts from './fetchOpts';
import {
  createEmitEvent,
} from './events';
import createCleanse from './cleanse';

export default function createInfrastructure({
  document,
}) {
  const optInRepo = createOptIn();
  const optOutRepo = createOptOut();
  const saveInteraction = createSaveInteraction();
  const fetchOptsRepo = createFetchOpts();
  const emitEvent = createEmitEvent(document);
  const cleanseRepo = createCleanse();

  return {
    optInRepo,
    optOutRepo,
    saveInteraction,
    fetchOptsRepo,
    emitEvent,
    cleanseRepo,
  };
}


// WEBPACK FOOTER //
// ./src/infrastructure/composition.js